import { Component, ViewChild } from "@angular/core";
import { ILocation } from '@vierkant-software/types__api';
import { FormArray, FormGroup } from "@angular/forms";
import { Popover } from "primeng/popover";
import { AppService } from "src/services/app.service";
import { DraftForm } from "src/app/modules/ngx-draft";
import { AutoCompleteSelectEvent } from "primeng/autocomplete";
import { formatAddress } from "src/util/formatting/address";

@Component({
    templateUrl: './contacts.step.haml',
    styleUrls:   ['./contacts.step.sass'],
    standalone:  false
})
export class UserContactStep {
	static disableWarning = ['multiForm'];
	@DraftForm() form: FormGroup;

	@ViewChild('overlayPanel') overlayPanel: Popover | undefined;
	private lastAddressSearch: ILocation;
	addressResults: ILocation[] = [];
	addressSearch: string;
	showDescription: boolean;

	constructor(private appService: AppService) { }

	onResolve(data: {showDescription: boolean}) {
		this.showDescription = data.showDescription ?? false;
	}

	async onAddressSearched(ev: string){
		if (ev === this.lastAddressSearch?.displayAddress?.trim())
			return;
		try {
			this.addressResults = (await this.appService.api.LocationWorker.searchLocation(ev)).map(x => ({...x, displayAddress: formatAddress(x, true)}));
		} catch(error) {
			console.error('Error: searchLocation failed', error);
			this.addressResults = [];
		}
	}

	selectLocation(location: AutoCompleteSelectEvent) {
		console.log('loc:', location);
		this.form.get(['addresses', 0]).patchValue(location.value);
		this.lastAddressSearch = location.value;
	}

	get addresses(): FormArray {
		return <FormArray>this.form.get('addresses');
	}
}
